import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    PrimaryButton,
} from 'components/buttons';
import {
    Card,
    Help,
} from 'components/other';

import {
    formatCircle,
} from './helpers/format-circle';
import {
    formatDescription,
} from './helpers/format-description';
import {
    formatTitle,
} from './helpers/format-title';

import styles from './StatusCard.module.scss';

const StatusCard: FC<IProps> = (props) => {
    return (
        <Card className={classNames(styles.statusCard, props.className)}>
            <img
                className={styles.circle}
                src={formatCircle(props.type)}
                alt={''}
            />
            <div className={styles.title}>
                {formatTitle(props.type)}
            </div>
            <div className={styles.description}>
                {formatDescription(props.type)}
            </div>
            {
                props.url &&
                <PrimaryButton
                    className={styles.button}
                    text={'Go to Merchant Site'}
                    href={props.url}
                />
            }
            {
                props.type === 'FAILED' &&
                <Help
                    className={styles.help}
                    text={'Need help? Contact merchant support.'}
                />
            }
        </Card>
    );
};

export default StatusCard;
